import { render, staticRenderFns } from "./cust_payment_component.vue?vue&type=template&id=31ce512a&scoped=true&"
import script from "../../assets/customer/js/payment.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/payment.js?vue&type=script&lang=js&"
import style0 from "./cust_payment_component.vue?vue&type=style&index=0&id=31ce512a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce512a",
  null
  
)

export default component.exports